// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Practices_wrapper__3h5b_","list":"Practices_list__1pqBs","container":"Practices_container__aymxw"};